import React from 'react'
import { Box } from '@mui/material'
import { PageWithScrollableCard } from '../common/layout/PageWithScrollableCard'
import { useTranslation } from '../common/hooks'
import { PrivacyStatementButtons } from './PrivacyStatementModal/PrivacyStatementButtons'
import { localStorageKey } from '../utils/localStorageKey'
import { useHistory } from 'react-router-dom'

const PrivacyStatement: React.FC<React.PropsWithChildren<unknown>> = () => {
  const { t } = useTranslation()
  const history = useHistory()

  const privacyStatement = localStorage.getItem(
    localStorageKey.privacyStatement
  )
  const privacyStatementAccepted = JSON.parse(privacyStatement ?? 'false')

  return (
    <Box display="flex" height="100%" flexDirection="column">
      <PageWithScrollableCard
        pageTitle={t('footer:menu.privacyStatement')}
        markdownTextInCard={t('common:privacyStatement')}
      />

      {!privacyStatementAccepted && (
        <Box px={12} pb={2} bgcolor="grey.200">
          <PrivacyStatementButtons onClose={() => history.goBack()} />
        </Box>
      )}
    </Box>
  )
}

export { PrivacyStatement }
